export const IS_HIDDEN_FROM_PORTAL = 'is_hidden_from_portal';
export const SHOULD_APPLICANT_SELF_ADVANCE = 'should_applicant_self_advance';
